class CountdownBanner extends HTMLElement {
  connectedCallback() {
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    this.mode = this.dataset.mode;
    this.durationHours = parseFloat(this.dataset.durationHours) || 24;
    this.hideOnExpire = this.dataset.hideOnExpire === 'true';
    this.storageKey = 'countdown-banner-' + this.dataset.sectionId;

    this.target = this.getTarget();
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getTarget() {
    const now = Date.now();

    if (this.mode === 'fixed') {
      const parsed = this.dataset.endDatetime ? new Date(this.dataset.endDatetime).getTime() : NaN;
      return isNaN(parsed) ? now : parsed;
    }

    let stored = null;
    try {
      stored = window.localStorage.getItem(this.storageKey);
    } catch (e) {}

    let target = stored ? parseInt(stored, 10) : NaN;
    if (!target || isNaN(target) || target <= now) {
      target = now + this.durationHours * 60 * 60 * 1000;
      try {
        window.localStorage.setItem(this.storageKey, String(target));
      } catch (e) {}
    }

    return target;
  }

  tick() {
    const now = Date.now();
    let remaining = this.target - now;

    if (remaining <= 0 && this.mode === 'evergreen') {
      this.target = now + this.durationHours * 60 * 60 * 1000;
      try {
        window.localStorage.setItem(this.storageKey, String(this.target));
      } catch (e) {}
      remaining = this.target - now;
    }

    if (remaining < 0) remaining = 0;

    const totalSeconds = Math.floor(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

    if (remaining <= 0 && this.mode === 'fixed') {
      clearInterval(this.interval);
      if (this.hideOnExpire) {
        this.closest('.countdown-banner').style.display = 'none';
      }
    }
  }
}

customElements.define('countdown-banner', CountdownBanner);
